import React, { useEffect, useRef } from 'react';
import { ContentTrackerProps } from './types';
import { TrackEvent } from '../../../enums/Content/TrackEvent';
import AudioPlayer, { AudioPlayerProps } from '../../AudioPlayer';
import MediaTracker from '../../../Services/Analytics/MediaTracker';

export interface AudioTrackerProps
  extends AudioPlayerProps,
    ContentTrackerProps {}

const AudioTracker: React.FC<AudioTrackerProps> = (
  props: AudioTrackerProps
): JSX.Element => {
  const { contactId, contentId, roomId, track, version, ...audioPlayerProps } =
    props;

  /**
   * We only track playback time for audios
   * - We don't do viewport detection
   * - We don't turn off the tracker if another content is in fullscreen
   * - We don't turn off the tracker if the window loses focus
   *
   * Let MediaTracker be in charge of calling tracker.setActive based
   * on player interactions (play, pause, seek and other events)
   */
  const { current: tracker } = useRef(
    new MediaTracker(
      TrackEvent.AUDIO_LISTENED_SECONDS,
      contentId,
      contactId,
      roomId,
      version
    )
  );

  const audioRef = useRef<HTMLAudioElement>(null);

  useEffect(() => {
    if (!track) {
      return;
    }

    tracker.attach(audioRef.current);
    return () => tracker.detach();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [audioRef]);

  return <AudioPlayer ref={audioRef} {...audioPlayerProps} />;
};

export default AudioTracker;
